import { makeStyles } from '@material-ui/core/styles';
import { colors } from '~/style/global';

export const useStyles = makeStyles(() => ({
  icon: {
    color: `${colors.green} !important`,
  },
}));

